export default __webpack_public_path__ + "static/media/img12.f5df4105.webp";